import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { parse } from 'date-fns';
import { updateSelectedDate } from 'store/schedule/schedulePageOperation';
import usePrintSchedule from './usePrintSchedule';


export const useScheduleCoreLogic = () => {
  const dispatch = useDispatch();
  const { printCurrent } = usePrintSchedule();

  const [worklogsForPrint, setStateWorklogsForPrint] = useState([]);
  const [needToSetWorklogs, setNeedToSetWorklogs] = useState(false);
  const [needToPrint, setNeedToPrint] = useState(false);


  const updatePrintWorklogsControl = (value) => () => {
    if (value !== needToPrint) {
      setNeedToPrint(value);
    }
  }

  const updateSetWorklogsControl = (value) => () => {
    if (value !== needToSetWorklogs) {
      setNeedToSetWorklogs(value);
    }
  }

  const setWorklogsForPrint = useCallback((worklogs) => {
    setStateWorklogsForPrint(worklogs);
    setNeedToPrint(true);
    setNeedToSetWorklogs(false);
  }, []);

  const changeSelectedDateFromUrl = useCallback(
    (dateString) => {
      if (!dateString) return;
      const parsed = parse(dateString, 'yyyy-MM-dd', new Date());
      dispatch(updateSelectedDate(parsed));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!needToSetWorklogs) return;

    printCurrent((worklogs) => {
      setWorklogsForPrint(worklogs || []);
    });
  }, [needToSetWorklogs, printCurrent, setWorklogsForPrint]);

  const api = {
    worklogsForPrint,
    needToSetWorklogs,
    needToPrint,
    updatePrintWorklogsControl,
    updateSetWorklogsControl,
    setWorklogsForPrint,
    changeSelectedDateFromUrl,
    printCurrent,
  };

  return api;
};

export default useScheduleCoreLogic;

